<template>
  <main>
    <site-navigation/>
    <router-view/>
  </main>
</template>

<script>
import SiteNavigation from './components/siteNavigation.vue';

  export default {
    async created() {
        await this.$http.get("/csrf");
    },
    components: { SiteNavigation }
}
</script>

<style>

html, body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
